import Vue from 'vue'

import AppLayout from './layout/index.vue'
import router from './router'
import store from './store'

import './mixins'
import './plugins'
import './thirdParty'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import dayjs from 'dayjs'
import VSwatches from 'vue-swatches'
import excel from 'vue-excel-export'
// import vueChartJs from 'vue-chartjs'

// theme essencial - import custom scss file
import './scss/custom.scss'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(dayjs)
Vue.use(excel)
Vue.use(VSwatches)
// Vue.use(vueChartJs)
const commitWindowWidth = () => store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth)

new Vue({
  name: 'Root',
  router,
  store,
  mounted () {
    commitWindowWidth()
    window.addEventListener('resize', commitWindowWidth)
  },

  beforeDestroy () {
    window.removeEventListener('resize', commitWindowWidth)
  },
  render: h => h(AppLayout)
}).$mount('#app')
